import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { CustomerListItem, CustomerPhase, CustomerStatus, CustomerTier, CustomerUsedProduct } from '@/features/stacktrace/customers/-query/type';

/**
 * 顧客一覧 (Product Central グローバルメニュー) のテーブル列ID。
 *
 * 表示項目:
 *   コード / 取引先 / 重要度 / ステータス / フェーズ /
 *   利用プロダクト / 利用開始日 / 担当者
 */
export const CustomerTableColumns = {
  CODE: 'CODE',
  BUSINESS_PARTNER: 'BUSINESS_PARTNER',
  TIER: 'TIER',
  STATUS: 'STATUS',
  PHASE: 'PHASE',
  USED_PRODUCTS: 'USED_PRODUCTS',
  START_DATE: 'START_DATE',
  OWNER: 'OWNER'
} as const;
export type CustomerTableColumns = EnumUnion<typeof CustomerTableColumns>;
export type CustomerTableRowData = {
  /** Customer ID（行クリックでの詳細遷移用。列としては表示しない） */
  id: string;
  [CustomerTableColumns.CODE]: string;
  [CustomerTableColumns.BUSINESS_PARTNER]: string | null;
  [CustomerTableColumns.TIER]: CustomerTier | null;
  [CustomerTableColumns.STATUS]: CustomerStatus;
  [CustomerTableColumns.PHASE]: CustomerPhase;
  [CustomerTableColumns.USED_PRODUCTS]: CustomerUsedProduct[];
  [CustomerTableColumns.START_DATE]: string | null;
  [CustomerTableColumns.OWNER]: string | null;
};
export const convertCustomerItemToTableRow = (item: CustomerListItem): CustomerTableRowData => {
  return {
    id: item.id,
    [CustomerTableColumns.CODE]: item.code,
    [CustomerTableColumns.BUSINESS_PARTNER]: item.businessPartnerName,
    [CustomerTableColumns.TIER]: item.tier ?? null,
    [CustomerTableColumns.STATUS]: item.status,
    [CustomerTableColumns.PHASE]: item.phase,
    [CustomerTableColumns.USED_PRODUCTS]: item.usedProducts,
    [CustomerTableColumns.START_DATE]: item.startDate,
    [CustomerTableColumns.OWNER]: item.ownerPersonName
  };
};